/* Section: arrivals — horizontal carousel.
   Arrows scroll one "page" (= visible width of the track) with smooth
   behavior. Disables an arrow at either end of the track. */
(() => {
  const section = document.querySelector('[data-section="arrivals"]');
  if (!section) return;

  const track = section.querySelector('[data-arrivals-track]');
  const prev  = section.querySelector('.arrivals__arrow--prev');
  const next  = section.querySelector('.arrivals__arrow--next');
  if (!track) return;

  const page = () => {
    // scroll by one card-width + gap, falling back to viewport
    const first = track.querySelector('.product-card');
    if (!first) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 16;
    return first.getBoundingClientRect().width + gap;
  };

  const atStart = () => track.scrollLeft <= 2;
  const atEnd   = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

  const updateDisabled = () => {
    if (prev) prev.disabled = atStart();
    if (next) next.disabled = atEnd();
  };

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -page(), behavior: 'smooth' });
  });
  next?.addEventListener('click', () => {
    track.scrollBy({ left: page(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateDisabled, { passive: true });
  window.addEventListener('resize', updateDisabled);
  updateDisabled();

  // drag-to-scroll with pointer events — only capture after real movement
  // so a plain click on a card still navigates to the product page.
  const DRAG_THRESHOLD = 8;
  let startX = 0, startScroll = 0, pointerId = null, dragging = false;

  track.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    pointerId = e.pointerId;
    startX = e.clientX;
    startScroll = track.scrollLeft;
    dragging = false;
  });

  track.addEventListener('pointermove', (e) => {
    if (pointerId !== e.pointerId) return;
    const delta = e.clientX - startX;
    if (!dragging && Math.abs(delta) > DRAG_THRESHOLD) {
      dragging = true;
      try { track.setPointerCapture(pointerId); } catch {}
      track.style.scrollSnapType = 'none';
      track.style.cursor = 'grabbing';
    }
    if (dragging) {
      track.scrollLeft = startScroll - delta;
    }
  });

  const endDrag = () => {
    if (pointerId == null) return;
    const wasDragging = dragging;
    if (wasDragging) {
      // swallow the trailing click so we don't navigate after a drag
      const block = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
      track.addEventListener('click', block, { capture: true, once: true });
      try { track.releasePointerCapture(pointerId); } catch {}
    }
    pointerId = null;
    dragging = false;
    track.style.scrollSnapType = '';
    track.style.cursor = '';
  };
  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);

  // Quick-add is handled globally in js/quick-add.js (delegated click).
  // Color swatches are rendered server-side via the product-card snippet,
  // and click swap is handled globally in js/card-swatches.js.
})();
